import {
    ActionType,
    getInformationListAction,
    getInformationAction,
    registerInformationAction,
    deleteInformationAction
} from "./actions";
import { InformationJson } from "../../../domain/information/Information";
import { createSlice } from "@reduxjs/toolkit";

export type InformationState = Readonly<{
    informations: InformationJson[] | null,
    information: InformationJson | null,
    registerSucceeded: boolean,
    registerFailed: boolean,
    deleteSucceeded: boolean,
    deleteFailed: boolean,
    processing: number
}>;

const informationInitialState: InformationState = {
    informations: null,
    information: null,
    registerSucceeded: false,
    registerFailed: false,
    deleteSucceeded: false,
    deleteFailed: false,
    processing: 0
};

const slice = createSlice({
    name: ActionType.base,
    initialState: informationInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getInformationListAction.pending,
                (state) => {
                    state.informations = [];
                    state.processing += 1;
                }
            )
            .addCase(
                getInformationListAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    const { informations } = payload;
                    state.informations = informations;
                    state.processing -= 1;
                }
            )
            .addCase(
                getInformationListAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                getInformationAction.pending,
                (state) => {
                    state.information = null;
                    state.processing += 1;
                }
            )
            .addCase(
                getInformationAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    const { information } = payload;
                    state.information = information;
                    // state.informationsをnullにした場合useInformationList()でお知らせ取得処理が走る
                    state.informations = null;
                    state.processing -= 1;
                }
            )
            .addCase(
                getInformationAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                registerInformationAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                registerInformationAction.fulfilled,
                (state, action) => {
                    state.information = action.payload.information;
                    // state.informationsをnullにした場合useInformationList()でお知らせ取得処理が走る
                    state.informations = null;
                    state.processing -= 1;
                }
            )
            .addCase(
                registerInformationAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                deleteInformationAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                deleteInformationAction.fulfilled,
                (state) => {
                    // state.informationsをnullにした場合useInformationList()でお知らせ取得処理が走る
                    state.informations = null;
                    state.processing -= 1;
                }
            )
            .addCase(
                deleteInformationAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            );
    }
});

export const informationReducer = slice.reducer; 
